import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGeneral = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1678 2.84668C16.4849 5.39534 18.1338 8.58057 18.951 11.2246C19.6935 9.96782 20.16 8.52361 20.16 6.66406C22.9423 11.1645 23.7878 14.8254 23.7967 14.8643L23.7899 14.8672C23.9764 15.5887 24.076 16.3464 24.076 17.127C24.076 19.5224 23.1405 21.697 21.619 23.2979L16.2645 28.7373C16.1353 28.8688 15.9811 28.9735 15.8113 29.0449C15.6416 29.1163 15.4593 29.1531 15.2752 29.1533C15.091 29.1535 14.9081 29.117 14.7381 29.0459C14.5683 28.9748 14.4143 28.8705 14.285 28.7393L8.91193 23.2979C7.39025 21.697 6.4549 19.5224 6.4549 17.127C6.45491 14.5509 7.66417 12.5214 9.26544 10.6045C9.99794 9.7276 13.5406 5.86221 13.1678 2.84668Z",
		fill: "currentColor"
	})
});
export default SvgGeneral;
